import { Text, Button, Flex } from "@chakra-ui/react";
import { useQuery } from "@apollo/client";
import { LOAD_PROJECTS } from "../../Queries";
import Loader from "../../Helpers/Loader";
import Project from "./Project";
import { useState } from "react";
import { ProjectProps } from "./Types";

const FavoritesTab = () => {
  const [page, setPage] = useState(1);
  const [loadingMore, setLoading] = useState(false);
  const { data, loading, error, fetchMore } = useQuery(LOAD_PROJECTS, {
    variables: { page, favorite: true, published: false },
  });

  const loadMore = async () => {
    setLoading(true);
    await fetchMore({
      variables: {
        page: page + 1,
        favorite: true,
        published: false,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        console.log(prev, fetchMoreResult);
        return {
          ...prev,
          projects: {
            ...prev.projects,
            items: [...prev.projects.items, ...fetchMoreResult.projects.items],
          },
        };
      },
    });
    setLoading(false);
    setPage(page + 1);
  };

  if (loading) return <Loader />;
  if (error) return <Text color="red">{error.message}</Text>;
  return (
    <>
      {data.projects.total === 0 && (
        <Text align="center">Проектов не найдено</Text>
      )}
      <Flex wrap="wrap">
        {data.projects.items.map((item: ProjectProps) => (
          <Project {...item} key={`p${item.id}`} />
        ))}
      </Flex>
      {data.projects.total > 0 &&
        data.projects.items.length < data.projects.total && (
          <Button isFullWidth onClick={loadMore} isLoading={loadingMore}>
            Еще
          </Button>
        )}
    </>
  );
};

export default FavoritesTab;
